<template>
  <section class="hh-legal">
    <v-container class="py-16">
      <v-row justify="center">
        <v-col
          cols="12"
          md="8"
        >
          <p
            v-if="kicker"
            class="hh-legal__kicker mb-3"
          >
            {{ kicker }}
          </p>
          <h1 class="hh-h2 mb-3">
            {{ title }}
          </h1>
          <p
            v-if="updated"
            class="hh-muted mb-10"
          >
            {{ updatedLabel }}: {{ updated }}
          </p>

          <div class="hh-legal__body">
            <slot />
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
  export default {
    name: 'BaseLegalPage',

    props: {
      kicker: String,
      title: String,
      updated: String,
      updatedLabel: {
        type: String,
        default: 'Last updated',
      },
    },
  }
</script>

<style lang="sass">
  .hh-legal
    &__kicker
      color: var(--hh-cyan)
      font-weight: 500

    &__body
      font-size: 1.05rem
      line-height: 1.7
      max-width: 42em

      h2
        font-family: var(--hh-font-display)
        font-weight: 500
        font-size: 1.5rem
        line-height: 1.3
        margin: 2em 0 .6em
        color: var(--hh-text)

      h2:first-child
        margin-top: 0

      p
        color: var(--hh-muted)
        margin-bottom: 1em

      ul, ol
        color: var(--hh-muted)
        margin-bottom: 1.2em
        padding-left: 1.4em

      li
        margin-bottom: .4em

      strong
        color: var(--hh-text)

      a
        color: var(--hh-cyan) !important
        text-decoration: none

        &:hover
          text-decoration: underline

    &__contact
      border: 1px solid var(--hh-line)
      border-radius: 12px
      padding: 16px 20px
      display: grid
      gap: 6px
</style>
